module.exports = __webpack_public_path__ + "ceccd35089fd20b56bdd8f53ca78adc2.pdf";